import { useContext } from 'react';

import { AddressLatLngContext, AddressNotAccContext, CheckDistanceContext, DeleteLatLngContext, GeocodeContext, LocationLoadingContext, MapOptionsContext, UpdateMapOptionsContext } from '../context';

export const useUpdateMapOptions = () => useContext(UpdateMapOptionsContext)!;
export const useLocationLoading = () => useContext(LocationLoadingContext)!;
export const useAddressLatLng = () => useContext(AddressLatLngContext)!;
export const useCheckDistance = () => useContext(CheckDistanceContext)!;
export const useAddressNotAcc = () => useContext(AddressNotAccContext)!;
export const useDeleteLatLng = () => useContext(DeleteLatLngContext)!;
export const useMapOptions = () => useContext(MapOptionsContext)!;
export const useGeocode = () => useContext(GeocodeContext)!;